import { render, staticRenderFns } from "./FinishedProductPhotosGallery.vue?vue&type=template&id=60c67473&scoped=true&"
import script from "./FinishedProductPhotosGallery.vue?vue&type=script&lang=ts&"
export * from "./FinishedProductPhotosGallery.vue?vue&type=script&lang=ts&"
import style0 from "./FinishedProductPhotosGallery.vue?vue&type=style&index=0&id=60c67473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c67473",
  null
  
)

export default component.exports